import React from 'react';
import { useUserSettings } from '../../hooks/useUserSettings';
import LoadingSpinner from '../ui/LoadingSpinner';
import { Eye } from 'lucide-react';

export default function Preferences() {
  const { settings, loading, error, updateSettings } = useUserSettings();

  if (loading) {
    return <LoadingSpinner message="Loading preferences..." />;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  const handleAnonymizingModeChange = async (enabled: boolean) => {
    try {
      await updateSettings({ anonymizing_mode: enabled });
    } catch (err) {
      console.error('Failed to update anonymizing mode:', err);
    }
  };

  return (
    <div className="card p-6">
      <h2 className="text-xl font-semibold mb-6">Preferences</h2>
      
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <Eye className="w-5 h-5 text-primary-500" />
              <h3 className="font-medium">Anonymizing Mode</h3>
            </div>
            <p className="text-sm text-gray-400">
              When enabled, sensitive contact information will be hidden in the UI
            </p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={settings?.anonymizing_mode || false}
              onChange={(e) => handleAnonymizingModeChange(e.target.checked)}
            />
            <div className="w-11 h-6 bg-dark-700 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-500 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-500"></div>
          </label>
        </div>
      </div>
    </div>
  );
}